import { createContext } from "react";
import defaultContext from "./defaults";

const Context = createContext(defaultContext);

export default Context;